<div [formGroup]="parentFormGroup()" class="input-container">
  <div class="input-container">
    <mat-form-field appearance="outline" class="input-field">
      <mat-label>{{ "SHARED.ADDRESS_SECTION.ZIP_CODE" | translate }}</mat-label>
      <input
        [attr.data-testid]="category() + '-zip-code'"
        matInput
        type="text"
        name="zipCode"
        formControlName="zipCode"
      />
      <mat-error appErrorMessages="zipCode" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-field">
      <mat-label>{{ "SHARED.ADDRESS_SECTION.CITY" | translate }}</mat-label>
      <input
        [attr.data-testid]="category() + '-city'"
        matInput
        type="text"
        name="city"
        formControlName="city"
      />
      <mat-error appErrorMessages="city" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-field">
      <mat-label>{{ "SHARED.ADDRESS_SECTION.STREET" | translate }}</mat-label>
      <input
        [attr.data-testid]="category() + '-street'"
        matInput
        type="text"
        name="street"
        formControlName="street"
      />
      <mat-error appErrorMessages="street" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="input-field">
      <mat-label>{{
        "SHARED.ADDRESS_SECTION.STREET_NUMBER" | translate
      }}</mat-label>
      <input
        [attr.data-testid]="category() + '-street-number'"
        matInput
        type="text"
        name="streetNumber"
        formControlName="streetNumber"
      />
      <mat-error appErrorMessages="streetNumber" />
    </mat-form-field>
  </div>
</div>
